import { Component } from '@angular/core';

@Component({
  selector: 'am-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  isContentNoMaxWidth: boolean;

  constructor() {}
}
